module.exports = __webpack_public_path__ + "static/images/czq.b47cdea.png";